import { Button } from '@viastud/ui/button'
import { X } from 'lucide-react'

import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '#components/ui/dialog'

interface FreeLessonModalProps {
  open: boolean
  close?: () => void
  confirm?: () => void
  openChange: (open: boolean) => void
}

export function FreeLessonModal({ open, confirm, openChange, close }: FreeLessonModalProps) {
  return (
    <Dialog open={open} onOpenChange={openChange}>
      <DialogContent className="flex flex-col gap-8">
        <DialogHeader className="flex flex-row items-end justify-between">
          <DialogTitle className="justify-between text-xl font-bold text-gray-950">
            Cours Gratuit
          </DialogTitle>
          <DialogClose asChild>
            <Button variant="none" className="m-0 h-6 w-6 justify-start p-0" onClick={close}>
              <X className="h-6 w-6" />
            </Button>
          </DialogClose>
        </DialogHeader>
        Ton cours offert est disponible. Il ne te reste plus qu’à commencer.
        <DialogFooter className="gap-6">
          <Button className="flex grow" onClick={confirm}>
            <p className="text-sm font-semibold">Réserver mon cours gratuit</p>
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}
